const configuredSiteUrl = process.env.REACT_APP_PUBLIC_SITE_URL || process.env.REACT_APP_BACKEND_URL;
const browserSiteUrl = typeof window !== "undefined" ? window.location.origin : "";
export const SITE_URL = (browserSiteUrl || configuredSiteUrl || "").replace(/\/$/, "");

export const siteUrl = (path = "/") => {
  if (!SITE_URL) throw new Error("Public site URL is not configured");
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
